const USER_ROLES = {
    ROLE_ADMIN: 'ROLE_ADMIN',
    ROLE_MANAGER: 'ROLE_MANAGER',
    ROLE_USER: 'ROLE_USER'
};

export default USER_ROLES;


// WEBPACK FOOTER //
// ./src/app/constants/userRoles.constants.js